import React, { Dispatch, SetStateAction } from 'react';
import { GPC, GPT, ValuationApproachGpcCompGroup, ValuationApproachPtCompGroup } from 'api';
import { CompGroupListCreateExtended, CompGroupSelected } from './types';

export interface CompGroupDialogContextType {
  currentComparisons: GPC[] | GPT[];
  compGroupList: Partial<CompGroupListCreateExtended>[];
  compGroupSelected: CompGroupSelected;
  setCompGroupSelected: Dispatch<SetStateAction<CompGroupSelected>>;
  setCompaniesToDelete: Dispatch<SetStateAction<number[]>>;
  setCompGroupToDelete: Dispatch<SetStateAction<number | null | undefined>>;
  setValid: Dispatch<SetStateAction<boolean>>;
  currentCompGroups: ValuationApproachPtCompGroup[] | ValuationApproachGpcCompGroup[];
  isGPC: boolean;
  defaultCompGroupId?: number | string | null;
}

const defaultCompGroupDialogContext: CompGroupDialogContextType = {
  currentComparisons: [],
  compGroupList: [],
  compGroupSelected: {
    companies: [],
  } as unknown as CompGroupSelected,
  setCompGroupSelected: () => {},
  setCompaniesToDelete: () => {},
  setCompGroupToDelete: () => {},
  setValid: () => {},
  currentCompGroups: [],
  isGPC: false,
  defaultCompGroupId: 0,
};

const CompGroupDialogContext = React.createContext<CompGroupDialogContextType>(defaultCompGroupDialogContext);
export default CompGroupDialogContext;
